export default __webpack_public_path__ + "static/media/DS-DIGIB.81b4bd92.TTF";